import { render, staticRenderFns } from "./BasicDashboardOrders.vue?vue&type=template&id=0936e187&lang=true"
import script from "./BasicDashboardOrders.vue?vue&type=script&lang=js"
export * from "./BasicDashboardOrders.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports